import React from 'react';
import cx from "classnames";
import {Button} from "@mui/material";
import type {ButtonProps} from "@mui/material";
import styles from './ButtonPrimary.module.scss';
import {checkCounterHasExpired} from "../../services/checkCounterHasExpired";

type ButtonPrimaryProps = Omit<ButtonProps, 'className'> & {
    isTransparent?: boolean;
    isWide?: boolean;
    label?: React.ReactNode;
    target?: React.HTMLAttributeAnchorTarget;
    rel?: string;
    className?: string | Record<string, boolean | undefined>;
};

const ButtonPrimary = ({ isTransparent, isWide, label, children, className, ...buttonProps }: ButtonPrimaryProps) => {

    const counterHasExpired = checkCounterHasExpired();

    return (
        <Button
            {...buttonProps}
            variant="contained"
            className={cx(styles.button, className, {
            [styles.buttonTransparent]: isTransparent,
            [styles.buttonSmall]: counterHasExpired,
            [styles.buttonWide]: isWide,
        })}
        >
            {children || <>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2.01 21L23 12L2.01 3L2 10L17 12L2 14L2.01 21Z" fill="currentColor"/>
                </svg>
                {label || (counterHasExpired ? 'Перейти' : 'Оставить заявку')}
            </>}
        </Button>
    );
};

export default ButtonPrimary;
